<script setup lang="ts">
// Barre d'onglets bas mobile (CDC §8.6.1). Visible <768px uniquement.
// 4 router-tabs : Inbox / Contacts / Agenda / Assistant + bouton Menu
// (5e) qui ouvre AppSidebar en drawer pour acceder aux sections moins
// frequentes (Brief / Recherche / Etiquettes / Regles / Autonomie /
// Reglages). P8.H + drawer mobile v2.10.5.

import { useUiStore } from "@/features/ui/stores/ui-store";

interface Tab {
  to: string;
  icon: string;
  label: string;
}

const TABS: Tab[] = [
  { to: "/", icon: "📥", label: "Inbox" },
  { to: "/contacts", icon: "👥", label: "Contacts" },
  { to: "/calendar", icon: "📅", label: "Agenda" },
  { to: "/assistant", icon: "💬", label: "Assistant" },
];

const ui = useUiStore();
</script>

<template>
  <nav class="tab-bar" aria-label="Navigation principale">
    <router-link v-for="t in TABS" :key="t.to" :to="t.to" class="tab" exact-active-class="active">
      <span class="icon" aria-hidden="true">{{ t.icon }}</span>
      <span class="label">{{ t.label }}</span>
    </router-link>
    <button
      type="button"
      class="tab tab-menu"
      :class="{ active: ui.sidebarOpen }"
      :aria-label="ui.sidebarOpen ? 'Fermer le menu' : 'Ouvrir le menu'"
      @click="ui.toggleSidebar()"
    >
      <span class="icon" aria-hidden="true">☰</span>
      <span class="label">Menu</span>
    </button>
  </nav>
</template>

<style scoped>
.tab-bar {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(64px + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  background: var(--color-navy-light);
  border-top: 1px solid rgba(232, 160, 32, 0.2);
  z-index: 30;
}
.tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  color: var(--color-gray);
  text-decoration: none;
  font-size: 0.7rem;
  min-height: 48px;
  padding: 0.4rem 0;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: var(--font-sans);
}
.tab .icon {
  font-size: 1.4rem;
}
.tab.active {
  color: var(--color-or);
}
.tab:hover {
  background: rgba(232, 160, 32, 0.05);
}
.tab-menu {
  border-left: 1px solid rgba(232, 160, 32, 0.12);
}

@media (max-width: 767px) {
  .tab-bar {
    display: flex;
  }
}
</style>
